var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-loading",class:_vm.pageLoading ? 'page-loading--active': ''},[(_vm.pageLoading)?_c('div',{staticClass:"spinner"}):_vm._e(),_c('session-timeout-modal'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }